import { Fragment, createContext, useContext, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectIsAuthenticated } from "../redux/auth/selectors"
import { selectGeneralApiData } from "../redux/general/selectors"
import { setAuthUser, setWebsites } from "../redux/actions"
import { GENERAL_API_CALLS } from "../redux/redux_constants.js"
import { generalApiCall } from "../redux/general/actions.js"
const _ = require("lodash")

const InfoCardCtx = createContext()

function InfoCardProvider({ children }) {
    const dispatch = useDispatch()
    const isAuthenticated = useSelector(selectIsAuthenticated)
    const websiteData = useSelector(selectGeneralApiData({ key: GENERAL_API_CALLS.WEBSITE_DATA }))

    useEffect(() => {
        if (
            (localStorage.getItem("token") && !isAuthenticated) ||
            (localStorage.getItem("token") && !localStorage.getItem("isLoggedIn"))
        ) {
            const user = localStorage.getItem("user")
            const parsedUser = JSON.parse(user)
            dispatch(
                generalApiCall({
                    endpoint: "api/v1/data",
                    params: {
                        page_name: "operators_list_v2",
                    },
                    headers: {
                        "App-Key": "master",
                    },
                    method: "POST",
                    key: GENERAL_API_CALLS.WEBSITE_DATA,
                }),
            )

            if (user) {
                dispatch(setAuthUser(parsedUser))
            }
            localStorage.setItem("isLoggedIn", "true")
        }
    }, [isAuthenticated])

    useEffect(() => {
        const parsedWebsites = websiteData

        if (parsedWebsites) {
            dispatch(setWebsites(parsedWebsites))
        }
    }, [websiteData])

    const renderInfoCardDataFunction = () => {
        return {}
    }

    return (
        <Fragment>
            <InfoCardCtx.Provider value={{ renderInfoCardData: renderInfoCardDataFunction }}>
                {children}
            </InfoCardCtx.Provider>
        </Fragment>
    )
}

export const useInfoCtx = () => {
    const ctx = useContext(InfoCardCtx)
    return ctx
}

export default InfoCardProvider
